<template>
    <div>

        <v-file-input id="upload" style="display:none;" @change="onUpload" />

        <v-row>
            <v-col cols="12" md="4" align="left">
                <div class="subtitle-2"><b>{{ $t('station_name') }}</b></div>
                <v-text-field
                    :value.sync="station_name"
                    @change="(val) => onchange('station_name',val)"
                    outlined
                    class="mt-1"
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
        </v-row>
        
        <div class="subtitle-2" align="left"><b>{{ $t('logo_and_banner') }}</b></div>
        <v-row class="ml-1">
            <v-col cols="12" md="4" align="left">
                <v-row :style="'background-image:url(' + banner + ');width:360px;height:90px;background-size: cover;'">
                    <v-col cols="12" md="4" align="left">
                        <v-img :src="logo" height="50" contain />
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-btn v-if="!disabled" small @click="upload('logo')">{{ $t('upload_logo') }}</v-btn>
                <v-btn v-if="!disabled" small @click="upload('banner')" class="mt-2">{{ $t('upload_banner') }}</v-btn>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col cols="12" md="8" align="left">
                <div class="subtitle-2"><b>{{ $t('station_detail') }}</b></div>
                <v-textarea
                    :value="station_detail"
                    @change="(val) => onchange('station_detail',val)"
                    class="mt-1"
                    outlined
                    :disabled="disabled"
                ></v-textarea>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col cols="12" md="8" align="left">
                <div class="subtitle-2"><b>{{ $t('station_annooucement_welcome') }}</b></div>
                <v-textarea
                    :value="station_annooucement_welcome"
                    @change="(val) => onchange('station_annooucement_welcome',val)"
                    class="mt-1"
                    outlined
                    :disabled="disabled"
                ></v-textarea>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col cols="12" md="8" align="left">
                <div class="subtitle-2"><b>{{ $t('station_annooucement_ula') }}</b></div>
                <v-textarea
                    :value="station_annooucement_ula"
                    @change="(val) => onchange('station_annooucement_ula',val)"
                    class="mt-1"
                    outlined
                    :disabled="disabled"
                ></v-textarea>
            </v-col>
        </v-row>
    </div>
</template>
<script>

  import config from '@/../config.js'
  import Staff from '@/model/instance/Staff.js'
  import axios from 'axios';

  export default {
    props: ['station_name','logo','banner','station_detail','station_code','onchange','disabled','station_annooucement_welcome','station_annooucement_ula'],
    data () {
        return {
            filename : ""
        }
    },
    methods : {
        upload(filename){
            this.filename = filename
            document.querySelector('#upload').click()
        },
        onUpload(file){

            var form = new FormData();
            form.append("uploaded_file", file);
            form.append("station_code", this.station_code);
            form.append("filename", this.filename);

            var que = this.$store.commit('addLoading')
            axios
            .post(config.api.url.manage.station.add_image,form,{headers: Staff.getTokenHeader()})
            .then(() => {
                this.$store.commit('finishLoading',que)
                this.$emit('onupload')
            })
            .catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })
        }
    }
  }
</script>